import Vue from 'vue'
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
import App from './App.vue'
import '@/plugins/index';
import router from "@/router";
import store from '@/store'
import i18n from "@/plugins/vue-i18n";
import axios from '@/plugins/axios'
import filters from '@/plugins/filters'
import 'jquery/src/jquery.js'
import '@/assets/scss/main.scss';
import '@/assets/css/main.css';

//RV
import "devextreme/dist/css/dx.light.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.common.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.light.css";
import "devexpress-reporting/dist/css/dx-webdocumentviewer.css";
//RD
import "ace-builds/css/ace.css";
import "ace-builds/css/theme/dreamweaver.css";
import "ace-builds/css/theme/ambiance.css"; 
import "devextreme/dist/css/dx.light.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.common.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.light.css";
import "@devexpress/analytics-core/dist/css/dx-querybuilder.css";
import "devexpress-reporting/dist/css/dx-webdocumentviewer.css";
import "devexpress-reporting/dist/css/dx-reportdesigner.css";

Vue.config.productionTip = false

/* Global error handler */
window.addEventListener('unhandledrejection', function(event) {
  //handle error here
  //event.promise contains the promise object
  //event.reason contains the reason for the rejection
  /*
  event.promise.catch((e) => {
    router.push({
      path: '/general-error'
    })
  })*/
});

new Vue({
  router,
  store,
  i18n,
  axios,
  filters,
  render: h => h(App),
  methods: {
    async applyUserLocale() {
      const userLocale = this.$store.getters['auth/user']?.lang;
      if (userLocale) {
        this.$i18n.locale = userLocale.toLowerCase();
        return;
      }

      try {
        const settings = await this.$store.dispatch('settings/getSettingsForGeneralUsage');

        if (settings) {
          const langSetting = settings.find(setting => setting.code === 'LANG');
          if (langSetting && langSetting.value) {
            this.$i18n.locale = langSetting.value.toLowerCase();
          }
        }
      } catch (error) {
        // No-op: settings endpoint may be unavailable before login.
      }
    }
  },
  async mounted() {
    await this.applyUserLocale();

    this.$store.watch(
      (state, getters) => getters['auth/check'],
      (isLoggedIn) => {
        if (isLoggedIn) {
          this.applyUserLocale();
        }
      }
    );

    this.$store.watch(
      (state, getters) => getters['auth/user']?.lang,
      (lang) => {
        if (lang) {
          this.$i18n.locale = lang.toLowerCase();
        }
      }
    );
  }
}).$mount('#app')
